import { Button } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

const SearchButton = ({
  text,
  onClick,
  disabled,
  isLoading,
}: {
  text?: string;
  onClick?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}) => {
  return (
    <Button
      startIcon={<SearchOutlinedIcon />}
      disabled={disabled || isLoading}
      variant="contained"
      color="primary"
      sx={{
        height: "100%",
      }}
      fullWidth
      onClick={onClick}
    >
      {isLoading ? "Lädt..." : text ? text : "Suchen"}
    </Button>
  );
};

export default SearchButton;
